// extracted by mini-css-extract-plugin
export default {"BetaLabel":"RegexField-module__BetaLabel__K6IVhCo","TestButton":"RegexField-module__TestButton__pwVELoB"};